import React from 'react';
import { ArrowRightIcon, FlameIcon } from 'lucide-react';
export function UrgencyBanner() {
  return <a href="#precios" aria-label="Ver la oferta del kit" className="group block w-full bg-brand-orange text-white" data-id="element-349">
      <span className="mx-auto flex max-w-4xl items-center justify-center gap-2 px-4 py-2.5 text-center text-xs font-bold leading-tight sm:text-sm" data-id="element-350">
        <FlameIcon className="h-4 w-4 shrink-0 fill-orange-100" aria-hidden="true" data-id="element-351" />
        <span data-id="element-352">
          <span className="text-orange-100" data-id="element-353">PRECIO DE LANZAMIENTO</span> — Esta
          semana el kit está a $390 UYU. Después sube a $590.
        </span>
        <span className="hidden items-center gap-1 rounded-full border border-white/25 bg-white/10 px-3 py-1 sm:inline-flex" data-id="element-354">
          Ver kit <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-355" />
        </span>
      </span>
    </a>;
}